import styles from "./productEngraving.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import ReactSidebar from "@/components/common/ReactSidebar";
import { lowerHeaderZIndex } from "@/redux/actions/headerAction";
import { generalConstants } from "@/utils/constants";
import MTOMessage from "../MTOMessage";
import { openEngraveSidebar } from "@/redux/actions/addToCartAction";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function ProductEngraving({
  engravingAdded,
  setEngravingAdded,
  productDetails,
  engravedFonts,
  estimatedDate,
  selectedVariant
}) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [engravingLabel, setEngravingLabel] = useState("Add engraving");
  const [fontsLoaded, setFontsLoaded] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const engraveSidebarOpen = useSelector((state) => state.click.open_engrave_sidebar);
  const [minMaxChar, setMinMaxChar] = useState({
    min: null,
    max: null,
  });
  const [metallicVariant, setMetallicVariant] = useState();
  const [engraveBGImage, setEngraveBGImange] = useState();
  const [selectedFont, setSelectedFont] = useState();
  const [engravingSidebarOpen, setEngravingSidebarOpen] = useState(false)
  const [metallicVariantColorClass, setMetallicVariantColorClass]=useState();
  const isDesktop= useMediaQuery("(min-width: 1025px)");

  const metalColorClassMap = {
    "yellow gold": {
      "text_color": "text-gold",
      "bg_color": "YellowGold"
    },
    "rose gold": {
      "text_color": "text-rosegold",
      "bg_color": "RoseGold"
    },
    "white gold": {
      "text_color": "text-steel-white",
      "bg_color": "WhiteGold"
    },
    "platinum": {
      "text_color": "text-steel-white",
      "bg_color": "WhiteGold"
    },
    "sterling silver": {
      "text_color": "text-steel-white",
      "bg_color": "WhiteGold"
    },
    "stainless steel": {
      "text_color": "text-steel-white",
      "bg_color": "stainless_steel"
    }
  };

  //based on the variant selected its metal color is used to display engrave bg
  useEffect(() => {
      setMetallicVariant(selectedVariant?.metalColor?.value.toLowerCase());     
      setMetallicVariantColorClass(metalColorClassMap[selectedVariant?.metalColor?.value.toLowerCase()] ); 
  }, [selectedVariant]);


  useEffect(() => {
    setEngraveBGImange(generalConstants.engraving_metal_color[metallicVariantColorClass?.bg_color])
  }, [metallicVariantColorClass]);
  let fonts = []
  //as part of below code when font url will be there then only it will be listed
  engravedFonts.forEach((font) => {
    const displayNameField = font.fields.find(field => field?.key === 'font_display_name');
    const fileUrlField = font.fields.find(field => field?.key === 'font_file_url');
    if(fileUrlField) {
      fonts.push({
        name: displayNameField ? displayNameField.value : '',
        url: fileUrlField ? JSON.parse(fileUrlField.value)[0] : '' // Parse the URL from the string
    })
    }
  });
  // const fonts = engravedFonts.map(font => {
  //   const displayNameField = font.fields.find(field => field.key === 'font_display_name');
  //   const fileUrlField = font.fields.find(field => field.key === 'font_file_url');

  //   return {
  //       name: displayNameField ? displayNameField.value : '',
  //       url: fileUrlField ? JSON.parse(fileUrlField.value)[0] : '' // Parse the URL from the string
  //   };
  // });
  const loadFont = (font) => {
        if (!fontsLoaded[font.name] && font.url) {

          if(font.url.includes("cdn.shopify.com")) {
          const style = document.createElement('style');
          style.appendChild(document.createTextNode(`
              @font-face {
                  font-family: '${font.name}';
                  src: url('${font.url}') format('woff2'), /* Adjust format as needed */
                      url('${font.url.replace('.woff2', '.woff')}') format('woff'); /* Fallback */
                  font-weight: normal;
                  font-style: normal;
              }
          `));
          document.head.appendChild(style);
          } else {
                const link = document.createElement('link');
                link.href = font.url;
                link.rel = 'stylesheet';
                document.head.appendChild(link);
                setFontsLoaded((prev) => ({ ...prev, [font.name]: true }));
                link.type= 'font/woff';
          }
          setFontsLoaded((prev) => ({ ...prev, [font.name]: true }));
      }
  };
  const getFontFamily = (fontName) => {
    return fontsLoaded[fontName] ? `${fontName}, sans-serif` : 'sans-serif'; // Fallback font
  };
  useEffect(() => {
    const sourceDivs = document?.querySelectorAll('.sourceDiv');
    const targetDiv = document.getElementById('targetDiv');
    
    if (sourceDivs && sourceDivs.length > 0) {
      // Get all elements with the class 'sourceDiv'
      const initialSourceStyles = window.getComputedStyle(sourceDivs[0]);
      targetDiv.style.fontFamily = initialSourceStyles?.fontFamily;
      sourceDivs[0].classList.add('active_font');
      // Add click event listener to each source div
      sourceDivs?.forEach(div => {
          div.addEventListener('click', function() {
              // Get the computed styles of the clicked source div
              const sourceStyles = window.getComputedStyle(this);
              
              // Apply only the font family to the target div
              targetDiv.style.fontFamily = sourceStyles.fontFamily;

              sourceDivs.forEach(div => {
                div.classList.remove('active_font');
              });

              // Add 'selected' class to the clicked source div
              this.classList.add('active_font');
          });
      });
    }
  }, [fontsLoaded]);

  //to change text dynamically
  const handleChange = (event) => {
    const alphanumericCharRegex = /^[a-z0-9 ]*$/i
    if(!alphanumericCharRegex.test(event.target.value)) {
        setErrorMessage(`You can only add letters, numbers and spaces`);
    } else if (minMaxChar.max && event.target.value?.length > minMaxChar.max) {
      setErrorMessage(`Max ${minMaxChar.max} letters`);
    } else {
      if (errorMessage) {
        setErrorMessage("");
      }
      setInputValue(event.target.value);
      if(event.target.value && engravingAdded["engraving_text"] && event.target.value != engravingAdded["engraving_text"]) {
        setEngravingLabel("Update engraving")
      }
    }
  };

  const handleBlurOut = (e) => {
    if (minMaxChar.min && e.target.value?.length < minMaxChar.min) {
      setErrorMessage(`Min ${minMaxChar.min} ${minMaxChar.min === 1 ? " letter" : " letters"}`);
    } else {
      setInputValue(e.target.value)
    }
  };
  let isSidebarActionInProgress = false;
  const handleSidebarClose = (e) => {
    if(errorMessage && !errorMessage?.includes("Min")) {
      setErrorMessage("")
    }
    if (isSidebarActionInProgress) return; // Prevent re-entry
    isSidebarActionInProgress = true;

    //setEngravingSidebarOpen(prev => !prev);
    dispatch(openEngraveSidebar(!engraveSidebarOpen));
    dispatch(lowerHeaderZIndex(false));
    isSidebarActionInProgress = false; // Reset the flag
};
const handleSidebar = (e) => {
  if (isSidebarActionInProgress) return; // Prevent re-entry
  isSidebarActionInProgress = true;

  fonts.forEach(loadFont);
  if (fonts && fonts[0]?.name) {
      setSelectedFont(fonts[0]?.name);
  }
  if(errorMessage && !errorMessage?.includes("Min")) {
    setErrorMessage("")
  }
   //setEngravingSidebarOpen(prev => !prev);
   dispatch(openEngraveSidebar(!engraveSidebarOpen));
  dispatch(lowerHeaderZIndex(e));

  isSidebarActionInProgress = false; // Reset the flag
};

  // generate label for input field based on 
  const generateInputLabel = () => {
    if (minMaxChar.max && minMaxChar.min) {
      return `Engraving text (min ${minMaxChar.min} ${minMaxChar.min === 1 ? " letter" : " letters"} & max ${minMaxChar.max} letters):`;
    } else if (minMaxChar.max) {
      return `Engraving text (max ${minMaxChar.max} letters):`;
    } else if (minMaxChar.min) {
      return `Engraving text (min ${minMaxChar.min} letters):`;
    } else {
      return `Engraving text:`;
    }
  };

  //check if Add engraving button is disabled
  //if no fonts are listed then button will remain disabled
  const isDisabled = () => {
    if(!inputValue?.trim() || inputValue?.trim()?.length < minMaxChar.min || !fonts.length) {
        return true
    } else if (errorMessage && errorMessage?.includes("Min")) {
        return true
    }
    return false
  }

  useEffect(() => {
    // Set min and max characters
    let obj = {};
    if (productDetails?.maximumCharacter)
      obj.max = productDetails?.maximumCharacter?.value;
    if (productDetails?.minimumCharacter)
      obj.min = productDetails?.minimumCharacter?.value;
    setMinMaxChar(obj);
  }, [productDetails]);

  const engraveText = engravingAdded.engraving_text
    ? `Free engraving added <span class="right"><span class="hover remove-engraving" tabindex="0">Remove</span></span>`
    : `Add engraving <i class="ga-product-engraving">(optional)</i>  <span class="right"><span class="bold ga-product-engraving">Free</span> <img height=18 src="/images/Icons/Plus/large.svg" class="hover ga-product-engraving"></img></span>`;

  const engraveMainContent = () => {
    return (
      <>
        <div className={styles.content}>
        <div className={`${styles.sticky_header}`}>
            <div onClick={handleSidebarClose} class="text-end close_block" role="button">
                 <span class="x-small-xs small-sm small-md">Close</span>
            </div>
            <div className={`${styles.editor_bg} ${!metallicVariantColorClass? styles['default_color']: ''} ${metallicVariantColorClass?.text_color}`}  style={{
                    ...(engraveBGImage ? { backgroundImage: `url(${engraveBGImage})` } : {}),
                    backgroundSize: 'cover',
                    backgroundPosition: 'top top'
                }} >
                <div id="targetDiv">{inputValue && inputValue.length >=1 ? inputValue : 'Engraving'}</div>
            </div>
        </div>
        <div
          className={styles.eng_content_wrapper}
        >
            <div className={styles.font_style_display}>
                <span className="small-md small-sm small-xs">Choose a font style:</span> 
                <div className={styles.pillsWrapper}>
                    {fonts.map((font) => (
                            <div tabIndex={0} className={`large sourceDiv ${styles.pills}`} key={font.name} title={font.name} style={{ fontFamily: getFontFamily(font.name) }} onClick={() => {
                              setSelectedFont(font.name)
                              if(engravingAdded["engraving_font"] && engravingAdded["engraving_font"] != font.name) {
                                setEngravingLabel("Update engraving")
                              }
                              }}>
                                {font.name} 
                            </div>
                    ))}
                </div> 
            </div>
            <div className={styles.text_wrapper}>
                <label className="small-md small-sm small-xs">{generateInputLabel()}</label>
                <input className={`input_control normal-md small-xs normal-sm`}
                name="engrave"
                type="text"
                onBlur={handleBlurOut}
                value={inputValue}
                onChange={handleChange}
                placeholder="Enter engraving"
                aria-label="new-engrave-text"
                spellcheck="false"
                />
                {errorMessage && (
                <div
                    className={`x-small-xs x-small-sm x-small-md ${styles.form_error}`}
                >
                    {errorMessage}
                </div>
                )}
          </div>
        </div>
        <div className={styles.fixed_bottom_wrapper}>
            <div className="text-center">
                <MTOMessage estimatedDate={estimatedDate} shippingLeadTime={productDetails?.leadShippingTime} engravingAdded={engravingAdded["engraving_text"]} isDrawer={true}/>
                <button id="add-engraving" className={`btn-primary add-engrave ${isDisabled() && `disabled`}`} onClick={handleClick} tabIndex={0}><span className="">{engravingLabel}</span></button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const handleClick = () => {
    setEngravingAdded({"engraving_text":inputValue?.trim(" "),"engraving_font":selectedFont});
    dispatch(openEngraveSidebar(false));
    //setEngravingSidebarOpen(false);
    dispatch(lowerHeaderZIndex(false));
    setEngravingLabel("Add engraving")
  }

  const [removeEng, setRemoveEng] = useState(false);

  const removeEngraving=(e)=> {
      if(engravingAdded.engraving_text && e.target.classList.contains('remove-engraving')){
      //setEngravingSidebarOpen(false)
      setEngravingAdded("");
      setInputValue("");
      setEngravingLabel("Add engraving")
      const sourceDivs = document?.querySelectorAll('.sourceDiv');
      sourceDivs?.forEach(div => {
      div.classList.remove('active_font');
      });
      sourceDivs[0].classList.add('active_font');
      setRemoveEng(true);
      e.preventDefault();
      e.stopPropagation();
      }
      
  }

  useEffect(()=>{
    // retain focus after selecting remove engraving
    const handleKeyDown = (e) =>{
      if(removeEng){
        if(e?.target?.classList?.contains("remove-engraving")){
          document?.querySelector(".engraving")?.focus();
        }
      } else if(e?.key=="Enter" && (e?.target.classList.contains("ipad_close_icon1")||e?.target.classList.contains("add-engrave"))) {
        document?.querySelector(".engraving")?.focus();
      }
    }
    window.addEventListener('keydown',(e) => handleKeyDown(e));
    return () => {
      window.removeEventListener('keydown', (e) => handleKeyDown(e));
    };
  },[removeEng])

  return (
    <ReactSidebar
      mainContent={
        <div className={styles.engrave_wrapper}>
          <div
            tabIndex={0}
            className={`small normal-md engraving ${styles.engrave_title} 
            ${!engravingAdded.engraving_text ? "ga-product-engraving" : ""}
            `}
            dangerouslySetInnerHTML={{ __html: engraveText }}
            onClick={(e)=>removeEngraving(e)}
          ></div>
        </div>
      }
      sidebarContent={engraveMainContent()}
      handleSidebar={handleSidebar}
      rootClassName={`eng_wrapper`}
      styles={{
        sidebar: {
          position: "fixed",
          overflow: "auto",
        },
      }}
      sidebarOpen={engraveSidebarOpen}
      pullRight={true}
    />
  );
}
